<template>
  <router-view />
</template>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400;1,500&family=Libre+Franklin:wght@300;400;500;600&display=swap');

  :root {
    --cream: #FAF8F5;
    --charcoal: #2A2A2A;
    --grey: #5A5A5A;
    --light-grey: #E8E4DF;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Libre Franklin', sans-serif;
    background-color: var(--cream);
    color: var(--charcoal);
    overflow-x: hidden;
  }

  #app {
    font-family: 'Libre Franklin', sans-serif;
  }

  /* Smooth scroll */
  html {
    scroll-behavior: smooth;
  }

  /* Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .fade-in {
    animation: fadeIn 0.6s ease-out;
  }
</style>
